export default function formatCurrencyNoDecimal(fee) {
  if ((typeof fee !== "number" && typeof fee !== "string") || !fee) return "$0";
  return `$${Math.round(fee).toLocaleString("en-US")}`;
}
